import React from 'react';

import '../../../../styles/scss/style.css';
import Button from '../../atoms/Button';
import DashboardWordBuilder from '../../molecules/DashboardWordBuilder';
import TextParagraphIcon from '../../molecules/TextParagraphIcon';

export default ({ data, actions, handleChange, handleBlur, addTrigger, removeTrigger }) => (
  <div className='questionBuilder'>
    <div className='questionBuilder__container'>
      <TextParagraphIcon classType='questionBuilder__triggerText' icon='fa-comment' text='If user says:' />
      <div className='questionBuilder__triggers'>
        {actions.map((action, i) => (
          <DashboardWordBuilder
            key={i}
            id='actions'
            placeholder={action}
            handleBlur={handleBlur}
            onChange={handleChange}
            value={action}
            name={`${i}`}
            readOnly={data.includes(action)}
            onClick={e => removeTrigger(i)}
        />
        ))}
      </div>
      <Button
        id='add-trigger'
        classType='btn__trigger btn--iconLeft'
        text='Add trigger'
        iconLeft='fa-plus'
        onClick={e => addTrigger(e)}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/redux/components/organisms/QuestionBuilder/QuestionBuilder.js